import React from 'react'
import styled from 'styled-components'
import { useLanguage } from '../../../contexts/LanguageContext'

export const AboutPage = () => {
  const { t } = useLanguage();
  const paragraphs = t('about.paragraphs', { returnObjects: true }) as unknown as string[];

  return (
    <AboutSection>
      <AboutHeading>{t('about.heading')}</AboutHeading>
      {paragraphs.map((paragraph: string, idx: number) => (
        <AboutParagraph key={idx}>{paragraph}</AboutParagraph>
      ))}
    </AboutSection>
  )
}

const AboutSection = styled.section`
  max-width: 700px;
  margin: 0 auto;
  padding: 2rem 1rem;
  font-family: inherit;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

const AboutHeading = styled.h1`
  font-size: 24px;
  font-weight: 700;
`

const AboutParagraph = styled.p`
  font-size: 16px;
  color: #222;
`
